export default function emailToRequest(email) {
	return {
		group: email.group,
		value: email.value,
	};
}
